import { render, staticRenderFns } from "./ExportPopup.vue?vue&type=template&id=5201d70a"
import script from "./ExportPopup.vue?vue&type=script&lang=js"
export * from "./ExportPopup.vue?vue&type=script&lang=js"
import style0 from "./ExportPopup.vue?vue&type=style&index=0&id=5201d70a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports